export default __webpack_public_path__ + "static/color-picker-example-light-25c3ad27629580d6860038416be297e5.png";